// extracted by mini-css-extract-plugin
module.exports = {"grid":"IconGrid_grid__1YhD6","iconWrapper":"IconGrid_iconWrapper__BuWNi"};